import React, { useCallback, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import Sidebar from '../Sidebar/Sidebar';
import Topbar from '../Topbar/Topbar';
import './Layout.scss';

const DESKTOP_BREAKPOINT = 992;

const getInitialSidebarState = () => {
  if (typeof window === 'undefined') {
    return true;
  }
  return window.innerWidth >= DESKTOP_BREAKPOINT;
};

const Layout = ({ children }) => {
  const location = useLocation();
  const [isSidebarOpen, setIsSidebarOpen] = useState(getInitialSidebarState);

  const handleResize = useCallback(() => {
    if (typeof window === 'undefined') {
      return;
    }

    // Web versiyonunda resize'da otomatik açma kapalı
    // Kullanıcı manuel olarak kontrol edebilir
  }, []);

  useEffect(() => {
    if (typeof window === 'undefined') {
      return undefined;
    }

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [handleResize]);

  useEffect(() => {
    if (typeof window !== 'undefined' && window.innerWidth < DESKTOP_BREAKPOINT) {
      setIsSidebarOpen(false);
    }
  }, [location.pathname]);

  const toggleSidebar = () => setIsSidebarOpen((prev) => !prev);
  const closeSidebar = () => setIsSidebarOpen(false);

  return (
    <div className={`layout ${isSidebarOpen ? 'sidebar-open' : ''}`}>
      <Sidebar isOpen={isSidebarOpen} onClose={closeSidebar} onToggle={toggleSidebar} />
      <div className="layout-main">
        <Topbar onToggleSidebar={toggleSidebar} />
        <main className="layout-content" role="main">
          {children}
        </main>
      </div>
    </div>
  );
};

export default Layout;
